export default class Faq {
  constructor(containerId, data) {
    this.container = document.getElementById(containerId);
    this.data = data;
  }

  init() {
    this.render();
    this.bindEvents();
  }

render() {
  this.container.innerHTML = this.data
    .map(
      (item) => `
      <div class="faq-item">
        <div class="faq-question">
          <span class="faq-text">${item.question}</span>
          <span class="faq-icon"></span>
        </div>
        <div class="faq-answer">
          <p>${item.answer}</p>
        </div>
      </div>
    `
    )
    .join('');
}

  bindEvents() {
    const items = this.container.querySelectorAll('.faq-item');

    items.forEach((item) => {
      const question = item.querySelector('.faq-question');
      const answer = item.querySelector('.faq-answer');

      question.addEventListener('click', () => {
        const isActive = item.classList.contains('active');

        items.forEach(i => {
          i.classList.remove('active');
          i.querySelector('.faq-answer').style.maxHeight = null;
        });

        if (!isActive) {
          item.classList.add('active');
          answer.style.maxHeight = answer.scrollHeight + "px";

          // ✅ scroll uniquement en mobile
          if (window.matchMedia('(max-width: 768px)').matches) {
            setTimeout(() => {
              const navHeight = document.querySelector('nav').offsetHeight;
              const y = item.getBoundingClientRect().top + window.scrollY - navHeight - 20;

              window.scrollTo({
                top: y,
                behavior: 'smooth'
              });
            }, 200);
          }
        }
      });
    });

  }
}